module.exports = new __parcel__URL__("warrior.c1fa2d46.png").toString();